import { IHierarchyAPIQuery, IWellbore, HierarchyLevelType } from 'common/interfaces/hierarchy-entities';
import {
  HierarchyEntityName, deleteHierarchyEntityAPICallAction, getHierarchyEntitiesAPICallAction, getHierarchyEntityAPICallAction, postHierarchyEntityAPICallAction, putHierarchyEntityAPICallAction,
} from '../helpers/hierarchy-api-actions-factory';
import { createHierarchyEntitySlice } from '../../hierarchy-state-slice-factory';

const slice = createHierarchyEntitySlice<IWellbore>(HierarchyLevelType.Wellbore);

export const {
  itemsRequested: wellboresRequested,
  itemsRecieved: wellboresRecieved,
  itemsFailed: wellboresFailed,
  itemRecieved: wellboreRecieved,
  itemDeleteRecieved: wellboresDeleteRecieved,
} = slice.actions;

export default slice.reducer;

export const getWellbores = (params: Partial<IHierarchyAPIQuery>) => getHierarchyEntitiesAPICallAction(HierarchyEntityName.WELLBORE, params, wellboresRequested.type, wellboresFailed.type, wellboresRecieved.type);

export const getWellbore = (entityId: string, parentId: string) => getHierarchyEntityAPICallAction(HierarchyEntityName.WELLBORE, { entityId, parentId }, wellboresRequested.type, wellboresFailed.type, wellboreRecieved.type);

export const createWellbore = (data: Partial<IWellbore>) => postHierarchyEntityAPICallAction(HierarchyEntityName.WELLBORE, data, wellboresRequested.type, wellboresFailed.type, wellboreRecieved.type);

export const updateWellbore = (data: any) => putHierarchyEntityAPICallAction(HierarchyEntityName.WELLBORE, data.wellboreid, data, wellboresRequested.type, wellboresFailed.type, wellboreRecieved.type);

export const deleteWellbore = (data: Partial<IWellbore>) => deleteHierarchyEntityAPICallAction(HierarchyEntityName.WELLBORE, data.wellboreid!, wellboresRequested.type, wellboresFailed.type, wellboresDeleteRecieved.type);
